import React from 'react';
import ApiIPA from 'util/ApiIPA.js';
import { Button, Col, FormControl, Row } from 'react-bootstrap';
import { base64ToHex } from 'util/Utils';
import classNames from 'classnames';
import config from '../../../../config';

export const ParcelPalletScanningScreen = (props) => {
  const { PalletType, TrackingServiceType, TrackingNumber = '' } = props.screensData;
  return (
    <Row className="screen-content">
      <Col xs={6} className="text-center align-center">
        <div className="screen_title">
          {PalletType == 'Pallet'
            ? 'Please scan or enter the Pallet Barcode'
            : 'Please scan or enter the tracking number on the shipping label'}
        </div>
        {PalletType == 'Parcel' && (
          <div>
            <div className="top30 ">
              <Button
                className={classNames('btn btn-lg btn-primary set-width', {
                  'custom-btn --pink': TrackingServiceType == 'FedEx',
                })}
                data-testid="scan-fedex-button"
                onClick={() => {
                  props.setScreensData({ TrackingServiceType: 'FedEx' }, () => {
                    props.focusOnTrackingNumberInput();
                  });
                }}
              >
                Scan FedEx
              </Button>
            </div>
            <div className="top30 ">
              <Button
                className={classNames('btn btn-lg btn-primary set-width ', {
                  'custom-btn --pink': TrackingServiceType == 'USPS',
                })}
                style={{ backgroundColor: TrackingServiceType == 'USPS' ? '' : '' }}
                data-testid="scan-usps-button"
                onClick={() => {
                  props.setScreensData({ TrackingServiceType: 'USPS' }, () => {
                    props.focusOnTrackingNumberInput();
                  });
                }}
              >
                {'Scan USPS/UPS/RMA'}
              </Button>
            </div>
          </div>
        )}
        {(TrackingServiceType || PalletType == 'Pallet') && (
          <div className="top30 set-width" style={{ margin: '0 auto' }}>
            <FormControl
              value={TrackingNumber}
              data-testid="tracking-number-text-input"
              componentClass="textarea"
              ref={(trackingNumberInput) => {
                props.setTrackingNumberInput(trackingNumberInput);
              }}
              placeholder=""
              onKeyPress={(e) => {
                props.setScreensData({ TrackingNumberTyped: true });
              }}
              onChange={(e) => {
                onTrackingNumberChange(e, props);
              }}
              type="text"
            />
          </div>
        )}
        {(PalletType == 'Pallet' || (TrackingServiceType && PalletType == 'Parcel')) && (
          <div className="top30 ">
            <Button
              data-testid="next-screen-button"
              disabled={props.pending || TrackingNumber == ''}
              className="btn btn-lg btn-primary set-width "
              onClick={() => {
                onSubmit(props);
              }}
            >
              Continue
            </Button>
          </div>
        )}
      </Col>
    </Row>
  );
};

function onSubmit(props, customData = {}) {
  let { TrackingServiceType, TrackingNumber = '' } = props.screensData;

  if (customData.TrackingNumber) {
    TrackingNumber = customData.TrackingNumber;
  }
  if (props.pending) {
    return;
  }

  props.updateParentComponentState({ pending: true });
  const SKUmatch = TrackingNumber.match(/^[\s]*(\d+)\.(\d+)\.(\d+)(\.(\d+))?[\s]*$/);

  if (SKUmatch) {
    return props.displayMessage({
      messageCode: 'Please scan the tracking number or pallet barcode, not the product SKU',
    });
  }

  let trackingNumberToSet = TrackingNumber;

  if (TrackingServiceType == 'FedEx') {
    /* get 12 last digits from the number */
    if (trackingNumberToSet.length > 12) {
      trackingNumberToSet = trackingNumberToSet.slice(-12);
    }

    props.processScannedNumberCallback({
      trackingNumberToSet,
    });
  } else {
    getDataForScannedNumber(trackingNumberToSet, props)
      .then((responseData) => {
        props.updateParentComponentState({ pending: false });
        props.processScannedNumberCallback({ trackingNumberToSet });
      })
      .catch((err) => {
        props.displayMessage({
          messageType: 'warning',
          messageCode: err.message,
        });
        props.updateParentComponentState({ pending: false });
      });
  }
}

function onTrackingNumberChange(e, props) {
  const textValue = e.target.value;
  let dataToUpdate = { TrackingNumber: e.target.value };
  const { TrackingNumber = '' } = props.screensData;

  if (TrackingNumber.length > e.target.value.length) {
    dataToUpdate.TrackingNumberTyped = true;
  }
  props.setScreensData(dataToUpdate, () => {
    const { TrackingNumberTyped = false } = props.screensData;

    if (textValue == '') {
      props.setScreensData({ TrackingNumberTyped: false });
    } else if (!TrackingNumberTyped) {
      onSubmit(props, dataToUpdate);
    }
  });
}

function getDataForScannedNumber(scannedNumber, props) {
  let userId = base64ToHex(props.userReducer.user._id,{convertToHEXUUID: true});

  return ApiIPA.getServiceItem(scannedNumber, userId).then((response) => {
      if (!response.ok) {
        return response.text().then((bodyData) => {
          const parsedData = JSON.parse(bodyData);
          return Promise.reject({
            message:
              parsedData && parsedData.error
                ? parsedData.error
                : `Error occurred when getting data for ${scannedNumber}`,
          });
        });
      }

      return response.json();
    })
    .catch((err) => {
      return Promise.reject({
        message: err && err.message ? err.message : `Error occurred when getting data for number ${scannedNumber}`,
      });
    });
}

